class AutoSubmitForm {
    constructor(form) {
        this.form = form;
        this.triggers = this.form.querySelectorAll('.js-auto-submit-trigger');

        this.triggers.forEach((trigger) => {
            trigger.addEventListener('change', this.handleTriggerAction.bind(this));
        });
    }

    handleTriggerAction(event) {
        const {target} = event;

        if (target.dataset.isParent) {
            this.triggers.forEach((trigger) => {
                const element = trigger;
                if (element !== target && element.dataset.dependsOnParent) {
                    element.selectedIndex = 0;
                }
            });
        }

        this.form.submit();
    }
}

const autoSubmitForm = {
    init() {
        document.querySelectorAll('.js-auto-submit-form')
            .forEach((element) => {
                // eslint-disable-next-line no-new
                new AutoSubmitForm(element);
            });
    },
};

export default autoSubmitForm;
